<template>
  <!-- This component doesn't need hydration, so we don't pass any params -->
  <LazyHydrate>
    <ResponsiveWrapper
      v-bind="$attrs"
      :component="blok.component"
      :devices="blok.devices"
    >
      <div :class="[backgroundColorClass(blok.bgVariant), heightClass]" />
    </ResponsiveWrapper>
  </LazyHydrate>
</template>

<script setup>
import { computed } from 'vue'
import ResponsiveWrapper from '../components/ResponsiveWrapper.vue'
import { useColorPalette } from '../composables/colorPalette'

const props = defineProps({
  blok: {
    type: Object,
    default: () => {},
  },
  context: {
    type: Object,
    default: () => {},
  },
})

const { backgroundColorClass } = useColorPalette()
const heightClass = computed(() => {
  const size = props.blok.size || 'medium'
  const map = {
    tiny: 'h-6',
    small: 'h-12',
    medium: 'h-20',
    large: 'h-32',
    xl: 'h-48',
  }
  return map[size]
})
</script>
